import KTheme from './KTheme'
import deepmerge from 'deepmerge'

/**
 * 组件库基类
 * - 保留一个后门，以备控制全局组件
 */
export default function (newComponent) {
  const defaults = {
    props: {
      kTheme: null,
    },
    computed: {
      $kActiveTheme() {
        const { enabled, getThemeName, getAncestorTheme } = KTheme

        if (enabled && this.kTheme !== false) {
          return getThemeName(this.kTheme || getAncestorTheme(this))
        }

        return null
      },
    },
  }

  return deepmerge(defaults, newComponent)
}
